import { render, staticRenderFns } from "./homeCenterbet.vue?vue&type=template&id=e670ddae&"
import script from "./homeCenterbet.vue?vue&type=script&lang=js&"
export * from "./homeCenterbet.vue?vue&type=script&lang=js&"
import style0 from "./homeCenterbet.vue?vue&type=style&index=0&id=e670ddae&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports